import React, { useEffect } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { getCountries } from "@api/utilities"
import Select from "@src/components/select"

const CountrySelect = ({ className = '', label = 'Country', value, onChange, countries, getCountries }) => {
  useEffect(() => {
    getCountries()
  }, [getCountries])
  return (
    <div className={className}>
      {label && <label className='cs-label'  htmlFor={`__input-country`}>{label}</label>}
      <Select
        options={countries}
        value={countries.find(opt => opt.value === value)}
        isLoading={!countries || !countries.length}
        onChange={event => onChange(event.value)}
        clearable={false}/>
    </div>
  )
}

const mapStateToProps = state => ({
  countries: state.utilities.countries.list,
})

const mapDispatchToProps = dispatch => ({
  getCountries: bindActionCreators(getCountries, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CountrySelect)